import Constants from '@/Constants';
import { useGet } from '@/hooks/useGet';
import { useProgramClass } from '@/hooks/useProgramClass';
import { EntityType } from '@/models/EntityTypes';
import List from '@/models/List';
import { Program } from '@/models/Program';
import { ProgramClass } from '@/models/ProgramClass';
import React from 'react';
import { useParams } from 'react-router-dom';
import ProgramClassForm from '../ProgramClassForm';
import RegularClassForm from '../RegularClassForm';
import WorkshopClassForm from '../WorkshopClassForm';

const getEntityKey = (entityId: string, programClass?: ProgramClass): string | null => {
    if (programClass) {
        if (programClass.program.isCourseProgram) {
            return `${Constants.LMS_COURSES_URI}/${entityId}`;
        }
        return Constants.LMS_PROGRAM_URI.replace('%p', entityId);
    }

    return null;
};

const ClassForm: React.FC = () => {
    const { id, classId } = useParams<{ id: string; classId: string }>();

    const { programClass } = useProgramClass({
        programClassId: Number(classId),
        withEnrollmentsCount: true,
        withWorkshopContent: true,
    });

    const { data: entity } = useGet<List | Program>(getEntityKey(id, programClass));

    if (!entity) return null;

    const renderClassForm = () => {
        if (programClass) {
            if (programClass.program.isCourseProgram) {
                return entity.type === EntityType.WORKSHOP ? <WorkshopClassForm entity={entity} /> : <RegularClassForm entity={entity as List} />;
            }
            return <ProgramClassForm entity={entity as Program} />;
        }
        return null;
    };

    return renderClassForm();
};

export default ClassForm;
